<template>
	<div :class="['directory', { 'open': this.isOpen }]">
		<section class="directory-list">
			<ul v-for="(cat, index) in this.directoryData" :key="cat.title">
				<li :class="['title', { 'open' : cat.open || index == autoOpen }]" v-on:click="toggleCategory(index)">
					{{ cat.title }}
					<div class="arrow"></div>
				</li>
				<div v-if="cat.open || index == autoOpen" class="category">
					<!-- Render first item in list no matter what -->
					<li v-for="loc in cat.locations.slice(0, 1)" :key="loc.name" v-on:click="selectDirectoryItem(loc)" :class="[{ 'selected': lastItemTouched === loc.name }]">
						{{ loc.name }}
					</li>
					<!-- Insert emergency exit icons button if this is the 'information' section -->
					<li v-if="index==0" v-on:click="toggleEmergencyExitIcons" :class="[{ 'selected': exitsVisible === true }]">{{exitsTitle}}</li>
					<!-- Render remaining items in list if present -->
					<li v-for="loc in cat.locations.slice(1)" :key="loc.name" v-on:click="selectDirectoryItem(loc)" :class="[{ 'selected': lastItemTouched === loc.name }]">
						{{ loc.name }}
					</li>
					<!-- Render 'todays events' if we are in the information section -->
					<li v-if="todaysEventsData && index==0" v-on:click="showTodaysEvents" :class="[{ 'selected': lastItemTouched === 'events' }]">{{eventsTitle}}</li>
				</div>
			</ul>
		</section>
	</div>
</template>

<script>
	import localizationData from '../data/LocalizedStrings.json';

	export default {
		name: "Directory",
		data: function() {
			return {
				sharedStore: window.store,
				directoryData: [],
				lastItemTouched: "",
				eventsTitle: "",
				exitsTitle: "",
				autoOpen: 0
			}
		},
		computed: {
			isOpen: function() {
				return this.sharedStore.state.directoryOpen;
			},
			todaysEventsData: function() {
				let eventsLoaded = (this.sharedStore.state.todaysEventsData && this.sharedStore.state.todaysEventsData.listItems) 
					? this.sharedStore.state.todaysEventsData.listItems.length : false;
				return eventsLoaded;
			},
			exitsVisible: function() {
				return this.sharedStore.state.emergencyExitsVisible;
			}
		},
		watch: {
			"sharedStore.state.directoryData": function() {
				this.updateDirectoryData();
			},
			"sharedStore.state.lastDataUpdate": function() {
				this.updateDirectoryData();
			},
			"sharedStore.state.currentLocation": function(val) {
				if (val === "") {
					this.lastItemTouched = "";
				}
			},
			"sharedStore.state.languageCode": function() {
				this.updateDirectoryData();
			}
		},
		methods: {
			toggleCategory: function(index) {
				if (this.autoOpen == 0) {
					this.autoOpen = -1;
					this.directoryData[0].open = true;
				}
				this.directoryData[index].open = !this.directoryData[index].open;
			},
			selectDirectoryItem: function(loc) {
				this.lastItemTouched = loc.name;
				this.sharedStore.setBackTarget("directory");
				this.sharedStore.setDirectoryOpen(false);
				this.sharedStore.setDirectorySelection(loc.code);
				this.sharedStore.setSubcategorySelection(loc.sub);
			},
			updateDirectoryData: function() {
				let currentDirData = [];
				let allData = this.sharedStore.state.directoryData;
				let languageCode = this.sharedStore.state.languageCode;

				if (!allData) {
					return;
				}

				allData.forEach(tab => {
					if (tab.categories) {
						tab.categories.forEach(cat => {
							let newCat = {
								title: cat["name_" + languageCode],
								locations: [],
								open: false
							}

							// locations with subcategories are contained in a single category
							if (cat.locations.length === 1 && cat.locations[0].subcategories.length) {
								// use subcategories instead
								if (cat.locations[0].hidden === false) {
									newCat.locations.push({
										id: cat.locations[0].id,
										name: localizationData.overview[languageCode],
										code: cat.locations[0].code,
										sub: ""
									});
									// subcategories are localized as a whole, not by individual fields
									cat.locations[0]["subcategories_" + languageCode].forEach(sub => {
										newCat.locations.push({
											id: sub.id,
											name: sub.name,
											code: cat.locations[0].code,
											sub: "_" + sub.name.replace(/[\s/]/g, '')
										});
									});
								}
							} else {
								cat.locations.forEach(loc => {
									if (loc.hidden === false) {
										newCat.locations.push({
											id: loc.id,
											name: loc["name_" + languageCode],
											code: loc.code,
											sub: ""
										});
									}
								});
							}

							if (newCat.locations.length) {
								currentDirData.push(newCat);
							}
    
						});
					}
				})

				this.directoryData = currentDirData;
				this.eventsTitle = this.sharedStore.state.todaysEventsData['title_' + languageCode] || "Today's Events";
				this.exitsTitle = localizationData.overview["emergencyExits"] || "Emergency Exits";
			},
			showTodaysEvents: function() {
				this.lastItemTouched = "events";
				this.$emit("showEvents");
			},
			toggleEmergencyExitIcons: function() {
				let nextExitIconState = !this.sharedStore.state.emergencyExitsVisible;
				this.lastItemTouched = "exits";
				this.sharedStore.setEmergencyExitsVisible(nextExitIconState);
				if (nextExitIconState === true) {
					this.sharedStore.setDirectoryOpen(false);
				}
			}
		}
	};
</script>

<style scoped lang="scss">
	.directory {
		position: absolute;
		bottom: 0;
		right: 0;
		width: 100%;
		height: 100%;

		display: flex;
		flex-direction: column;
		transition: 0.5s;
		
		
		transform: translateY(100%);
		background: rgb(25, 25, 25);
		color: #ffffff;

		touch-action: auto;

		&.open {
			transform: translateY(0);
		}

		@media (min-aspect-ratio: 1/1) {
			width: 50%;
			transform: translateY(0);
		}
	}

	ul {
		padding: 0;
	}

	.directory-list {
		overflow-y: scroll;
		padding-bottom: 100px;

		ul {
			padding: 0;
			margin: 0;
		}

		li {
			padding: 10px 65px;
			border-bottom: 2px solid rgb(33, 33, 33);
			text-align: left;

			&:not(.title) {
				cursor: pointer;
				transition: 0.2s;
				// transition-delay: 2.5s;
				background: rgba(255, 255, 255, 0);

				&.selected {
					color: rgb(0, 220, 200);
					transition: 0s;
				}
			}
		}
	}

	.title {
		font-weight: bold;
    color: rgb(0, 220, 200);    
    display: flex;
    justify-content: space-between;
    align-items: flex-end;

    &.open {
      color: black;
      background: white;
      align-items: flex-start;

      .arrow {
        border: solid black;
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
      }
    }

    .arrow {
      border: solid #9F9E9E;;
      border-width: 0 2px 2px 0;
      width: 15px;
      height: 15px;
      transform: rotate(225deg);
    }
	}

  .category {
    box-shadow: inset 0 -15px 30px -10px #000000; 
  }
</style>
